import { themeUi } from '../../themeUi/themeUi';

export const vectorSearch = {
  footerLinks: {
    color: themeUi.semantic.color.text.neutral600
  }
};
